import * as React from 'react';
import {
    getOmjsContainer,
    getOperationSafe,
    getFavListData,
    getOmjsProjectInstance
} from 'selectors';
import { actions as containersActions } from 'services/containers/containers-service';
import { IState } from 'services/root-reducer';

import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { FavoritesExportLayerChooserOperation } from 'services/overlay-windows/overlay-windows-service';
import { Popover } from 'components/popover';
import clsx from 'clsx';
import { ContainerExportButton } from './container-export-button';
import './layers-list.scss';

export interface IFavoritesExportLayerListProps extends WithTranslation {
    favoritesLayerExportOperation: FavoritesExportLayerChooserOperation;
    project: omjs.Project;
    iconExportButton?: boolean;
}
export interface IFavoritesExportLayerListState {
    showPopover: boolean
}

/**
 * Объект где ключом является код слоя, а значением является массив id объектов,
 * принадлежащие этому слою
 */
type RenderContainersMap = Record<string, number[]>;


const mapStateToProps = (state: IState) => ({
    favoritesLayerExportOperation: getOperationSafe(state, 'EXPORT_OBJECTS_LAYER_CHOOSER_OVERLAY'),
    project: getOmjsProjectInstance(state)
});

/* eslint-disable @typescript-eslint/indent */
class FavoritesExportLayerListComponent extends React.Component<
    IFavoritesExportLayerListProps,
    IFavoritesExportLayerListState
> {
/* eslint-enable @typescript-eslint/indent */
    btnRef;
    constructor(props: IFavoritesExportLayerListProps) {
        super(props);

        this.onExportContainerClick = this.onExportContainerClick.bind(this);
        this.btnRef = null;
        this.state = {
            showPopover: false
        };
    }

    getIconUrl(container: omjs.ProjectLayer) {
        let { project } = this.props;
        let iconUrl = container.get('icon');
        if (iconUrl.length) {
            if (iconUrl.charAt(0) !== '/') {
                iconUrl = `/${iconUrl}`;
            }
            let port = project.apiUrlLocation.port ? `:${project.apiUrlLocation.port}` : '';
            iconUrl = `${project.apiUrlLocation.protocol}//${project.apiUrlLocation.hostname}${port}${iconUrl}`;
        }
        return iconUrl;
    }

    onExportContainerClick(layer_code: string, object_ids: number[]) {
        if (object_ids.length < 500) {
            containersActions.exportObjects({
                container_code: layer_code,
                object_ids: object_ids
            });
        }
    }

    renderExportContainerItem(layer_code: string, object_ids: number[]) {
        let { i18n, iconExportButton = false } = this.props;
        let container = getOmjsContainer(false, layer_code);
        return (
            <div className='export-container-item' key={layer_code}>
                <div className="container-icon">
                    <img src={this.getIconUrl(container)} />
                </div>
                <div className="container-name">
                    {`${container.get('name')} (${i18n.t('OBJECTS_COUNT', { count: object_ids.length })})`}
                </div>
                <div className="container-export-button-wrapper">
                    {/**
                     * Тут можно было бы написать `this.onExportContainerClick.bind(this, container)`
                     * но линтер ругается на такие конструкции, поэтому был написан этот компонент-обертка
                     * который будет прокидывать `container` в `onClick`
                     */}
                    <ContainerExportButton
                        className={clsx(object_ids.length > 500 && 'export-button__disabled')}
                        iconInsteadText={iconExportButton}
                        layerCode={layer_code}
                        objectIds={object_ids}
                        onClick={this.onExportContainerClick}
                        onMouseEnter={(e) => {
                            if (object_ids.length > 500) {
                                this.btnRef = e.currentTarget;
                                this.setState({ showPopover: true });
                            }
                        }}
                        onMouseLeave={() => this.setState({ showPopover: false })}
                    />
                </div>
            </div>
        );
    }

    render() {
        let { favoritesLayerExportOperation, t } = this.props;
        let { objects } = favoritesLayerExportOperation.data;

        let containers: RenderContainersMap = objects.reduce<RenderContainersMap>(
            (accum, signature) => {
                if (!Object.prototype.hasOwnProperty.call(accum, signature.layer_code)) {
                    accum[signature.layer_code] = [];
                }
                accum[signature.layer_code].push(signature.object_id);
                return accum;
            }, {}
        );

        // return [ ...Object.entries(containers) ].map(
        //     ([ layer_code, object_ids ]) => this.renderExportContainerItem(layer_code, object_ids)
        // );
        return (
            <>
                {[ ...Object.entries(containers) ].map(
                    ([ layer_code, object_ids ]) => this.renderExportContainerItem(layer_code, object_ids)
                )}
                <Popover
                    className='export-button__popover'
                    open={this.state.showPopover}
                    hideTimeout={300}
                    showTimeout={300}
                    targetElement={this.btnRef}
                    offset={[ 0, 10 ]}
                    placement="bottom"
                >
                    {/* eslint-disable-next-line */}
                    {t(`Превышено количество объектов для выгрузки. Максимальное количество - 500 объектов. Для уменьшения количества объектов можете воспользоваться фильтром.`)}
                </Popover>
            </>
        );
    }
}

export const FavoritesExportLayerList = connect(mapStateToProps)(
    withTranslation()(FavoritesExportLayerListComponent)
);
